<script lang="ts">
  import { tweened } from "svelte/motion"
  import Guide from "./Guide.svelte"

  export let rotation = 0

  const a = tweened(rotation, { duration: 100 })

  $: a.set(rotation)
  $: direction =
    rotation < -0.05 ? ("up" as const) : rotation > 0.05 ? ("down" as const) : undefined
</script>

<div>
  <Guide rotation={$a} {direction} />
</div>

<style lang="postcss">
  * {
    @apply relative flex h-full w-full text-white;

    /* guide */
    & > :global(*) {
      @apply !absolute left-1/2 -translate-x-1/2;
    }
  }
</style>
